import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import UserPage from "@/pages/UserPage";
import VideoPage from "@/pages/VideoPage";
import ArtistPage from "@/pages/ArtistPage";
import PaymentPage from "@/pages/PaymentPage";
import AdminPage from "@/pages/AdminPage";
import { AuthProvider } from "@/context/AuthContext";
import { RadioProvider } from "@/context/RadioContext";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="usuario" element={<UserPage />} />
        <Route path="videos" element={<VideoPage />} />
        <Route path="artistas" element={<ArtistPage />} />
        <Route path="pagos" element={<PaymentPage />} />
        <Route path="admin" element={<AdminPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <RadioProvider>
        <div className="App min-h-screen bg-[#050505]">
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </div>
      </RadioProvider>
    </AuthProvider>
  );
}

export default App;
